import { classNames } from '@repo/ui/src/utils/classNames';
import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';
import { appConfig } from '../../utils/appConfig';

interface RightChevronProps extends IconWrapperProps {
  darkMode?: boolean;
  onImage?: boolean;
  arrowSize?: string;
}

const RightChevron = ({ darkMode, onImage, arrowSize, ...rest }: RightChevronProps) => {
  const lightMode = !darkMode && !onImage;

  return (
    <IconWrapper
      aria-hidden="true"
      width={arrowSize ?? '40'}
      height={arrowSize ?? '40'}
      viewBox="0 0 48 48"
      className={classNames(
        darkMode && appConfig.isTraeger && 'fill-neutral-100 hover:fill-warm-400',
        darkMode && appConfig.isMeater && 'fill-brand-300 hover:fill-red-400',
        onImage && 'fill-neutral-100 hover:fill-neutral-500',
        lightMode && 'fill-neutral-700 hover:fill-warm-400',
      )}
      {...rest}
    >
      <circle cx="24" cy="24" r="24" fill="inherit" />
      <path
        className={classNames(lightMode ? 'fill-neutral-100' : 'fill-neutral-700')}
        fillRule="evenodd"
        d="m21 14.1-1.414 1.415L28.07 24l-8.485 8.485L21 33.9l8.485-8.486L30.9 24l-1.415-1.414L21 14.1Z"
        clipRule="evenodd"
      />
    </IconWrapper>
  );
};

export default RightChevron;
